module.exports = __webpack_public_path__ + "static/media/terms-and-conditions-banner.5709052d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/terms-and-conditions-banner.jpg
// module id = 190
// module chunks = 0